<template>
   <div id="app">
    <div class="app-cont">
      <router-view  v-if="isRouterAlive"/>
    </div>
  </div>
</template>

<script>
// import BMap from "BMap";
//  import WebTop from "@/components/common/WebTop";
// import WebBtm from "@/components/common/WebBtm";
export default {
	name: "app",
	provide () {
    return {
      reload: this.reload
    }
	},
	data () {
    return {
      LocationCity:"正在定位",    //给渲染层定义一个初始值
      isRouterAlive: true
    }
  },
  components: {
    //  WebTop,
    /*WebBtm */
	},
    mounted() {
	    if(!this.$store.getters.getLocationCity || this.$store.getters.getLocationCity === '定位失败'){
            console.log('触发定位')
            this.mycity()    //触发获取城市方法
        }
        if (this.isMobile()) {
           location.replace('https://h5.2855855.com/');
        }/*  else {
          alert("pc端");
          this.$router.replace('http://www.2855855.com:9002/#/');
        } */
      },
    watch:{
      LocationCity:'cunchu'
    },
  methods: {
		isMobile() {
      let flag = navigator.userAgent.match( // match方法可在字符串内检索指定的值，
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    //存储本地
    cunchu(){
      this.$store.commit('upLocationCity',this.LocationCity)
    },
      mycity(){  //定义获取城市方法
          const geolocation = new BMap.Geolocation();
          var _this = this
          _this.LocationCity = "定位中..."
          geolocation.getCurrentPosition(function getinfo(position){
              let city = position.address.city;  //获取城市信息
              let province = position.address.province;  //获取省份信息
              _this.LocationCity = city
              _this.$http.get('customerUploadLocation?city=' + city + '&lat=' + position.latitude + '&lng=' + position.longitude).then(res => {
                  if(res.code == 200){}
              })
          }, function(e) {
              _this.LocationCity = "定位失败"
          }, {provider: 'baidu'});
      },
	reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
        })
	}

  },
  created(){

  }
};
</script>

<style>
@import "./assets/css/globalCss.css";
html{overflow:auto}
/* body{overflow:auto;height:99vh;width: 99vh;} */
</style>



// WEBPACK FOOTER //
// src/App.vue